import { render } from "./Minime.vue?vue&type=template&id=31c4c148&scoped=true"
import script from "./Minime.vue?vue&type=script&lang=js"
export * from "./Minime.vue?vue&type=script&lang=js"

import "./Minime.vue?vue&type=style&index=0&id=31c4c148&lang=scss&scoped=true"

import exportComponent from "/Users/pnz002/Project/dfy/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-31c4c148"]])

export default __exports__